import React, { useState } from "react"
import { Box, Button, TextField } from "@mui/material"
import { PageContainer } from "components"
import { DialogUpload } from "./DialogUpload"
import { FaFileUpload } from "react-icons/fa"
import { IoIosArrowForward } from "react-icons/io"
import { useTableParams } from "hooks/useTableParams"
import { toast } from "react-toastify"
import { BoxLink, BoxPlace, BoxUrl, ContainerConfig } from "./styles"
import { productService } from "services/productService"
import { Table } from "shared"

export const Skus = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [dialogUploadExcel, setDialogUploadExcel] = useState(false)
  const [editedRows, setEditedRows] = useState<Record<number, number>>({})
  const { count, data, params, refresh, onChange, status } = useTableParams({
    service: (params: any) => productService.getProducts(params),
    paramsDefault: { status: "active", orderBy: "name" },
  })

  const handleSaveChanges = async (lowerLimitProduct: number, productId: number) => {
    try {
      setIsLoading(true)
      await productService.patchProduct({ lowerLimitProduct }, productId)
      toast(`Produto ${productId} alterado para ${lowerLimitProduct} com sucesso!`, {
        type: "success",
      })
      refresh()
      setEditedRows(prev => {
        const updated = { ...prev }
        delete updated[productId]
        return updated
      })
    } catch (err: any) {
      toast(err?.message ?? `Erro ao atualizar produto ${productId}, dá um alô pro time de tech.`, {
        type: "error",
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleSkuSearch = (skuName: any) => {
    onChange({ ...params, skuName })
  }

  const handleFieldChange = (value: any, productId: any) => {
    setEditedRows(prev => ({
      ...prev,
      [productId]: Number(value),
    }))
  }
  return (
    <>
      <PageContainer>
        <Box>
          <BoxUrl>
            <BoxLink to="../configuracoes">Configurações</BoxLink>
            <IoIosArrowForward fontSize="1.125rem" />
            <BoxPlace>SKUs</BoxPlace>
          </BoxUrl>
          <ContainerConfig>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setDialogUploadExcel(true)}
            >
              <FaFileUpload size={"1rem"} style={{ marginRight: "0.6rem" }} /> Alterar em massa
            </Button>
          </ContainerConfig>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="center" style={{ marginTop: "20px" }}>
          <TextField
            label="Buscar pelo nome"
            variant="outlined"
            onChange={e => handleSkuSearch(e.target.value)}
            style={{ marginRight: "20px" }}
          />
        </Box>

        <Table
          columns={[
            {
              style: { fontSize: "1.2rem" },
              field: "sku",
              label: "SKU",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "name",
              label: "Nome",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "separationOrder",
              label: "Etapa",
            },
            {
              style: { fontSize: "1.2rem" },
              field: "lowerLimitProduct",
              label: "Limite (un)",
              renderCell: (row: any) => {
                return (
                  <TextField
                    type="number"
                    variant="outlined"
                    size="small"
                    defaultValue={editedRows[row?.data?.productId] || row?.data?.lowerLimitProduct}
                    onBlur={event => handleFieldChange(event.target.value, row?.data?.productId)}
                    style={{
                      fontSize: "1.2rem",
                      width: "7rem",
                    }}
                    error={
                      Number(editedRows[row?.data?.productId] || row?.data?.lowerLimitProduct) <= 0
                    }
                    helperText={
                      Number(editedRows[row?.data?.productId] || row?.data?.lowerLimitProduct) <= 0
                        ? "O valor deve ser maior que 0"
                        : ""
                    }
                  />
                )
              },
            },
            {
              style: { fontSize: "1.2rem" },
              field: "id",
              label: "",
              renderCell: (row: any) => (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() =>
                    handleSaveChanges(editedRows[row.data.productId], row?.data?.productId)
                  }
                  disabled={isLoading || editedRows[row.data.productId] == null}
                >
                  Salvar
                </Button>
              ),
            },
          ]}
          data={data}
          params={params}
          onChange={onChange}
          refresh={refresh}
          count={count}
          status={status}
          rowStyle={() => ({ ".MuiTableCell-root": { fontSize: "1.1rem" } })}
        />
      </PageContainer>
      <DialogUpload isOpen={dialogUploadExcel} setIsOpen={setDialogUploadExcel} getSkus={refresh} />
    </>
  )
}
